import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen text-white" style={{ backgroundColor: '#0a0a0a' }}>
      {/* Header */}
      <nav className="px-6 lg:px-12 py-6 border-b border-white/10">
        <div className="flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2">
            <img src="/revocut-logo.png" alt="RevoCut" className="w-10 h-10" />
            <span className="text-xl font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>REVOCUT</span>
          </button>
          <button 
            onClick={() => navigate(-1)}
            className="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </button>
        </div>
      </nav>

      {/* Content */}
      <main className="py-12 px-6 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Datenschutzerklärung
          </h1>

          <div className="space-y-8">
            <section 
              className="p-8 rounded-2xl border border-white/10"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
            >
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                1. Datenschutz auf einen Blick
              </h2>
              <h3 className="font-semibold text-white mb-2">Allgemeine Hinweise</h3>
              <p className="text-gray-400">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                personenbezogenen Daten passiert, wenn Sie unsere Website besuchen.
              </p>
            </section>

            <section 
              className="p-8 rounded-2xl border border-white/10"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
            >
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                2. Verantwortliche Stelle
              </h2>
              <div className="text-gray-400 space-y-1">
                <p>RevoCut Media</p>
                <p>[Adresse hier einfügen]</p>
                <p>
                  E-Mail:{' '}
                  <a href="mailto:info@revocut-media.de" className="hover:text-white transition-colors" style={{ color: '#5C63FF' }}>
                    info@revocut-media.de
                  </a>
                </p>
              </div>
            </section>

            <section 
              className="p-8 rounded-2xl border border-white/10"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
            >
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                3. Datenerfassung auf unserer Website
              </h2>
              
              <h3 className="font-semibold text-white mb-2">Kontaktformular / Projektanfragen</h3>
              <p className="text-gray-400 mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben 
                aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten 
                zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              
              <h3 className="font-semibold text-white mb-2">Server-Log-Dateien</h3>
              <p className="text-gray-400">
                Der Provider der Seiten erhebt und speichert automatisch Informationen in 
                so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt.
              </p>
            </section>

            <section 
              className="p-8 rounded-2xl border border-white/10"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
            >
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                4. Ihre Rechte
              </h2>
              <p className="text-gray-400">
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger 
                und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben 
                außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen.
              </p>
            </section>

            <section 
              className="p-8 rounded-2xl border border-white/10"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
            >
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                5. Cookies
              </h2>
              <p className="text-gray-400">
                Unsere Website verwendet nur technisch notwendige Cookies. Diese sind erforderlich, 
                um die grundlegenden Funktionen der Website sicherzustellen. Durch die Nutzung 
                unserer Website stimmen Sie der Verwendung von Cookies zu.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Datenschutz;
